<ngx-doc-viewer
	[googleCheckContentLoaded]="true"
	[googleCheckInterval]="3000"
	[url]="documentUrl"
	[viewer]="viewer"
	style="height: 100%"
></ngx-doc-viewer>
